export const variables: Record<string, { id: string; display: string }[]> = {
	order: [
		{
			id: "shop-name",
			display: "Shop Name",
		},
		{
			id: "order-id",
			display: "Order ID",
		},
		{
			id: "product-count",
			display: "Product Count",
		},
		{
			id: "order-total-value",
			display: "Order Total Value",
		},
		{
			id: "order-status",
			display: "Order Status",
		},
		{
			id: "shipping-carrier",
			display: "Shipping Carrier",
		},
		{
			id: "shipping-method",
			display: "Shipping Method",
		},
		{
			id: "tracking-number",
			display: "Tracking Number",
		},
	],
	customer: [
		{
			id: "full-name",
			display: "Full Name",
		},
		{
			id: "first-name",
			display: "First Name",
		},
		{
			id: "last-name",
			display: "Last Name",
		},
	],
};
